import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowUpWall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-up-wall"><path d="M16.5 8.25L12 3.75L7.5 8.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 20.25L4.75 20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 4.5V16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowUpWall;
